import { render } from "./sierra-webchat.vue?vue&type=template&id=8c4dd516"
import script from "./sierra-webchat.vue?vue&type=script&lang=js"
export * from "./sierra-webchat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__